// extracted by mini-css-extract-plugin
export default {"wrapper":"feed_wrapper__xJTr9","section":"feed_section__6iNii"};